import * as ColorPalette from './color';

export * from './dark';
export * from './light';
export { default as getDecisions } from './getDecisions';
export * from './getDecisions';
export * from './types';
export { ColorPalette };
